import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../lib/cn";
/**
 * The brand's `.stat`, measured.
 *
 * The figure is MONO at weight 400. Every other display type in the brand is
 * bold sans; numbers are the exception, and the tabular figures are what makes
 * a row of them line up. Getting this backwards (bold sans figures) is the
 * fastest way to make a dashboard look like it belongs to a different product.
 *
 * The value and label are one `<dl>` pair rather than two divs, so a screen
 * reader reads "Published sites, 128" rather than "128" floating alone.
 */
export function Stat({ className, value, label, foot, emphasis = false, ...props }) {
    return (_jsxs("div", { "data-slot": "stat", className: cn("lg:rounded-lg lg:border lg:border-hairline lg:bg-card lg:px-[1.4rem] lg:py-[1.5rem]", className), ...props, children: [_jsxs("dl", { children: [_jsx("dd", { "data-slot": "stat-value", className: cn("lg:mb-3 lg:block lg:font-mono lg:text-stat lg:font-normal lg:tabular-nums", emphasis ? "lg:text-primary" : "lg:text-strong"), children: value }), _jsx("dt", { "data-slot": "stat-label", className: "lg:text-body-sm lg:leading-snug lg:text-foreground", children: label })] }), foot !== undefined && (_jsx("p", { "data-slot": "stat-foot", className: "lg:mt-2 lg:text-caption lg:text-subtle lg:max-w-none", children: foot }))] }));
}
//# sourceMappingURL=stat.js.map